import styles from './textarea.module.css';
import Label from '../Label';

const TextArea = ({
  value,
  onChange,
  placeholder,
  name,
  label,
  inline = false,
  rows = 5,
  noBottomMargin = false,
}) => {
  return (
    <div style={{ display: 'flex', flexDirection: inline ? 'row' : 'column', marginBottom: noBottomMargin ? 0 : 20 }}>
      <Label name={name} text={label} />
      <textarea
        rows={rows}
        id={name}
        className={styles.textBox}
        value={value || ''}
        onChange={onChange}
        placeholder={placeholder}
      />
    </div>
  );
};

export default TextArea;
